import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { useGetAssignmentByVideoQuery } from '../features/assignment/assignmentApi';
import { userLoggedIn } from '../features/auth/authSlice';
import { useGetMarkByAssigQuery, useGetMarkByvideoandStdIdQuery, usePostMarkMutation } from '../features/marks/marksApi';
import { useGetQuizQuery } from '../features/quiz/quizApi';
import { useGetAllVideosQuery } from '../features/video/videoApi';

const CoursePlayer = () => {
const {pathname} =useLocation();
const[showVideo,setShowVideo]=useState({});
const {data:videos,isError,isLoading,isSuccess,error}=useGetAllVideosQuery();


const {user} = useSelector((state) => state.auth);

const dispatch=useDispatch()
const handleShowVideo =(video)=>{
  setShowVideo(video);

  const auth=JSON.parse(localStorage.getItem('auth'));
  localStorage.setItem(
    "auth",
    JSON.stringify({
        accessToken: auth.accessToken,
        user: {...auth.user,prevViewId:video.id},
    })
);


  dispatch(
    userLoggedIn({
        accessToken: auth.accessToken,
        user: {...auth.user,prevViewId:video.id},
    })
);
}

const {data:assignmentData}=useGetAssignmentByVideoQuery(showVideo?.id)
let content=undefined;

if(isLoading){
  content=<p>Loading............</p>
}
else if(!isLoading && isError){
  content=<p>Something went wrong!</p>

}
else if(!isLoading && !isError && isSuccess && videos?.length==0){
  content=<p>No Videos availabe!</p>

}

else if(!isLoading && !isError && isSuccess  && videos?.length > 0){
  content=videos.map(video=>( <div onClick={()=>handleShowVideo(video)} key={video.id} className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2">
  {/* Thumbnail */}
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z" />
  </svg>
  {/* Description */}
  <div clas="flex flex-col w-full">
    <a href="#">
      <p className="text-slate-50 text-sm font-medium">{video?.title}</p>
    </a>
    <div>
      <span className="text-gray-400 text-xs mt-1">{video?.duration} Mins</span>
      <span className="text-gray-400 text-xs mt-1"> | </span>
      <span className="text-gray-400 text-xs mt-1">{video?.views} views</span>
    </div>
  </div>
</div>))

}

const [show, setShow] = useState(false);

const handleClose = () => setShow(false);
const handleShow = () => setShow(true);

useEffect(()=>{
  if(user && videos){
    
    setShowVideo(videos?.find(v=>v.id == user?.prevViewId))
  }
},[user,videos]);

const [assignmentInfo, setAssignmentInfo]=useState({ });


useEffect(()=>{
  setAssignmentInfo(prev=>({...prev,"student_id": user?.id,
  "student_name": user?.name,
  "assignment_id":  assignmentData?.[0]?.id,
  "title":  assignmentData?.[0]?.title,
  "createdAt": new Date(),
  "totalMark": assignmentData?.[0]?.totalMark,
  "status": "pending"}))
},[assignmentData,user])


const [submitAssignemntRepo,{isLoading:submitLoading,isError:submitIsError,isSuccess:submitSuccess}]=usePostMarkMutation();
const {data:marksByAssignemnt,refetch}=useGetMarkByAssigQuery({assisId:assignmentData?.[0]?.id , stdId:user?.id});




useEffect(()=>{
  if(submitSuccess){
    handleClose()
refetch()
  }
},[submitSuccess])


const {data:isQuizAvailable}=useGetMarkByvideoandStdIdQuery({ videoId:showVideo?.id, stdId:user?.id });


const {data:quizsList}=useGetQuizQuery({videoId :showVideo?.id});

  return (
 <>
 <section className="py-6 bg-primary">
  <div className="mx-auto max-w-7xl px-5 lg:px-0">
    <div className="grid grid-cols-3 gap-2 lg:gap-8">
      <div className="col-span-full w-full space-y-8 lg:col-span-2">
        <iframe width="100%" className="aspect-video" src={showVideo?.url}title="Things I wish I knew as a Junior Web Developer - Sumit Saha - BASIS SoftExpo 2023" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
        <div>
          <h1 className="text-lg font-semibold tracking-tight text-slate-100">
            Things I wish I knew as a Junior Web Developer - Sumit Saha - BASIS SoftExpo 2023
          </h1>
          <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
            Uploaded on 23 February
            2020</h2>
          <div className="flex gap-4">
           {assignmentData?.length > 0 && marksByAssignemnt?.length==0 && <a onClick={handleShow} href="#" className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary">
              এসাইনমেন্ট
            </a>}
         {quizsList?.length > 0 &&  !isQuizAvailable?.length > 0 &&   <Link to={`/student/quiz/videoId=${showVideo?.id}`} className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary">কুইজে
              অংশগ্রহণ
              করুন</Link>}
          </div>
          <p className="mt-4 text-sm text-slate-400 leading-6">
            আপনারা যারা বিগিনার হিসেবে রিয়্যাক্ট জেস নিয়ে কাজ করা শুরু করেছেন, তারা রিয়্যাক্ট এর বেশ
            কিছু কনসেপ্ট ঠিক মতো আয়ত্ত না করতে পারার কারণে বিচিত্র কিছু সমস্যার সম্মুখীন হন এবং শেষ
            পর্যন্ত বুঝতে না
            পেরে হতাশ হয়ে পড়েন। তাদের জন্যই এই ভিডিওটি। এই ভিডিওতে আমি এমন ১০টি সমস্যার কথা তুলে ধরেছি
            যেগুলো
            বিগিনার হিসেবে আপনারা অহরহ সম্মুখীন হবেন। আশা করি ভিডিওটি দেখলে আপনাদের এই সমস্যাগুলো নিয়ে
            আর কনফিউশন
            থাকবেনা।
          </p>
        </div>
      </div>
      <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">


        {content}
     
      </div>
    </div>
  </div>
</section>


<>
  

      {show && (
        <>
          <div className="modal-backdrop" onClick={handleClose}></div>
          <div className="modal">
            <div className="modal-content">
              <span className="close" onClick={handleClose}>
                &times;
              </span>
              <form className="mt-8 space-y-6" onSubmit={e=>{
                e.preventDefault();
                submitAssignemntRepo({...assignmentInfo})
               
              }} >
                        <input type="hidden" name="remember" defaultValue="true" />
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <label htmlFor="name" className="sr-only">Repo Link</label>
                                <input onChange={(e)=>setAssignmentInfo(prev=>({...prev,repo_link:e.target.value}))} id="name" value={assignmentInfo?.repo_link} name="title" type="name" autoComplete="name" required className="login-input rounded-t-md" placeholder="Repo Link" />
                            </div>

                       

                           

                        </div>
                        <div>
                            <button disabled={submitLoading} type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
                                Submit
                            </button>
                        </div>
                    </form>
            </div>
          </div>
        </>
      )}
    </>

 </>
  )
}

export default CoursePlayer